import BigNum from "../math/BigNum";

export default class BigNumSave {
    constructor() {}

    /**
     * @param {BigNum} bigNumValue 
     * @returns {number[]}
     */
    static save(bigNumValue) {
        if (!bigNumValue) {
            return [0, 0];
        }

        return [
            bigNumValue.m,
            bigNumValue.e
        ];
    }

    /**
     * @param {number[]} bigNumState 
     * @param {BigNum} bigNumOutput 
     */
    static load(bigNumState, bigNumOutput) {
        if (!bigNumState) {
            return;
        }

        ///////bigNumOutput.fromMantissaExponent(bigNumState[0], bigNumState[1]);

        bigNumOutput.set(bigNumState[0], bigNumState[1]);
    }
}